import { Autocomplete, Grid } from "@mui/material";
import StyledTextField from "components/StyledTextField";
import { FC } from "react";
import { useAppSelector } from "store";

export interface OrderLineInfoInputProps {
  info01: string | null;
  setInfo01: (value: string | null) => void;
  info02: string | null;
  setInfo02: (value: string | null) => void;
  info03: string | null;
  setInfo03: (value: string | null) => void;
  info04: string | null;
  setInfo04: (value: string | null) => void;
}

export const OrderLineInfoInput: FC<OrderLineInfoInputProps> = (props) => {
  const { info01, info02, info03, info04, setInfo01, setInfo02, setInfo03, setInfo04 } = props;
  const { orderLineInfo } = useAppSelector((state) => state.cache);

  const info01Enabled =
    !!orderLineInfo.info01?.description && orderLineInfo.info01.description.length > 0;
  const info02Enabled =
    !!orderLineInfo.info02?.description && orderLineInfo.info02.description.length > 0;
  const info03Enabled =
    !!orderLineInfo.info03?.description && orderLineInfo.info03.description.length > 0;
  const info04Enabled =
    !!orderLineInfo.info04?.description && orderLineInfo.info04.description.length > 0;

  const info01Dropdown = orderLineInfo.info01Values?.description?.split(";") || [];
  const info02Dropdown = orderLineInfo.info02Values?.description?.split(";") || [];
  const info03Dropdown = orderLineInfo.info03Values?.description?.split(";") || [];
  const info04Dropdown = orderLineInfo.info04Values?.description?.split(";") || [];

  return (
    <>
      {info01Enabled &&
        (info01Dropdown.length > 0 ? (
          <Grid item container xs={12}>
            <Autocomplete
              id="info01"
              options={info01Dropdown}
              data-testid="info01"
              renderInput={(params) => (
                <StyledTextField
                  {...params}
                  name="info01"
                  className="info01"
                  label={orderLineInfo.info01?.description}
                />
              )}
              onChange={(_, value: string | null) => {
                setInfo01(value);
              }}
              value={info01}
              fullWidth
              defaultValue={null}
            />
          </Grid>
        ) : (
          <Grid item container xs={12}>
            <StyledTextField
              name="info01"
              className="info01"
              label={orderLineInfo.info01?.description}
              onChange={(event) => setInfo01(event.target.value)}
              fullWidth
            />
          </Grid>
        ))}

      {info02Enabled &&
        (info02Dropdown.length > 0 ? (
          <Grid item container xs={12}>
            <Autocomplete
              id="info02"
              options={info02Dropdown}
              data-testid="info02"
              renderInput={(params) => (
                <StyledTextField
                  {...params}
                  name="info02"
                  className="info02"
                  label={orderLineInfo.info02?.description}
                />
              )}
              onChange={(_, value: string | null) => {
                setInfo02(value);
              }}
              value={info02}
              fullWidth
            />
          </Grid>
        ) : (
          <Grid item container xs={12}>
            <StyledTextField
              name="info02"
              className="info02"
              label={orderLineInfo.info02?.description}
              onChange={(event) => setInfo02(event.target.value)}
              fullWidth
            />
          </Grid>
        ))}

      {info03Enabled &&
        (info03Dropdown.length > 0 ? (
          <Grid item container xs={12}>
            <Autocomplete
              id="info03"
              options={info03Dropdown}
              data-testid="info03"
              renderInput={(params) => (
                <StyledTextField
                  {...params}
                  name="info03"
                  className="info03"
                  label={orderLineInfo.info03?.description}
                />
              )}
              onChange={(_, value: string | null) => {
                setInfo03(value);
              }}
              value={info03}
              fullWidth
            />
          </Grid>
        ) : (
          <Grid item container xs={12}>
            <StyledTextField
              name="info03"
              className="info03"
              label={orderLineInfo.info03?.description}
              onChange={(event) => setInfo03(event.target.value)}
              fullWidth
            />
          </Grid>
        ))}

      {info04Enabled &&
        (info04Dropdown.length > 0 ? (
          <Grid item container xs={12}>
            <Autocomplete
              id="info04"
              options={info04Dropdown}
              data-testid="info04"
              renderInput={(params) => (
                <StyledTextField
                  {...params}
                  name="info04"
                  className="info04"
                  label={orderLineInfo.info04?.description}
                />
              )}
              onChange={(_, value: string | null) => {
                setInfo04(value);
              }}
              value={info04}
              fullWidth
            />
          </Grid>
        ) : (
          <Grid item container xs={12}>
            <StyledTextField
              name="info04"
              className="info04"
              label={orderLineInfo.info04?.description}
              onChange={(event) => setInfo04(event.target.value)}
              fullWidth
            />
          </Grid>
        ))}
    </>
  );
};
